const actions = {
    validatePaymentModal({ commit }, payload) {
        commit('VALIDATE_PAYMENT_MODAL', payload)
    },
    cancelOrderModal({ commit }, order) {
        commit('CANCEL_ORDER_MODAL', order)
    },
    shipmentModal({ commit }, shipment) {
        commit('SHIPMENT_MODAL', shipment)
    },
    updateShipmentModal({ commit }, shipment) {
        commit('UPDATE_SHIPMENT_MODAL', shipment)
    },
    updateSidebarCollapse({ commit }, status) {
        commit('UPDATE_SIDEBAR_COLLAPSE', status)
    },

    trackingNumberDrawer({ commit }, items) {
        commit('TRACKING_NUMBER_DRAWER', items)
    },
    textEditorDrawer({ commit }, content) {
        commit('TEXT_EDITOR_DRAWER', content)
    },
    textEditor({ commit }, content) {
        commit('TEXT_EDITOR', content)
    },

    setSegmentPersonnelModal({ commit }, payload) {
        commit('SET_segmentPersonnelModal', payload)
    },
    applySegmentPersonnelSelected({ commit }, payload) {
        commit('APPLY_segmentPersonnelModal', payload)
    },


    activeDesktopMenu({ commit }, payload) {
        commit('activeDesktopMenu', payload)
    },
    hasSearch({ commit }, payload) {
        commit('hasSearch', payload)
    },
    popMenu({ commit }, payload) {
        commit('popMenu', payload)
    },
    popShare({ commit }, payload) {
        commit('SET_POP_SHARE', payload)
    },

    setHomeAboutPopVideo({ commit }, payload) {
        commit('SET_HOME_ABOUT_POP_VIDEO', payload)
    },
}

export default actions